/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ConstraintId } from "../../commons/types/ConstraintId";
import { AppId } from "../../commons/types/AppId";
export const ConstraintResource = core.serialization.object({
    id: ConstraintId,
    appId: AppId,
    validator: core.serialization.string(),
    description: core.serialization.string().optional(),
    function: core.serialization.string().optional(),
    options: core.serialization.any().optional(),
    label: core.serialization.string().optional(),
    createdAt: core.serialization.date(),
    updatedAt: core.serialization.date(),
});
